export default {
    askDelete: 'Вы уверены, что хотите удалить?',
};
